<template>
  <span v-dompurify-html="highlightedText" />
</template>

<script>
import fuzzysort from 'fuzzysort'

export default {
  props: {
    fuzzyResult: {
      type: Object,
      required: true,
    },
    isFocused: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    highlightedText() {
      const className = this.isFocused
        ? 'search-text-highlight__text search-text-highlight__text--focused'
        : 'search-text-highlight__text'

      const testId = 'search-text-highlight'

      return fuzzysort.highlight(
        this.fuzzyResult,
        `<span class="${className}" data-testid="${testId}">`,
        '</span>'
      )
    },
  },
}
</script>

<style lang="scss">
@import 'silverfin-ui-kit/src/scss/tooling';

.search-text-highlight {
  &__text {
    @include background-color('warning', 'light');

    &--focused {
      @include background-color('warning');
    }
  }
}
</style>
